import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/accept.svg';

export const IconAccept: IconComponent = props => <Icon {...props} src={src} />;
